import { render } from "./SectionMyResume.vue?vue&type=template&id=b4ec41a6&scoped=true&ts=true"
import script from "./SectionMyResume.vue?vue&type=script&lang=ts"
export * from "./SectionMyResume.vue?vue&type=script&lang=ts"

import "./SectionMyResume.vue?vue&type=style&index=0&id=b4ec41a6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ec41a6"]])

export default __exports__